import { __awaiter, __generator } from "tslib";
import { deprecatedinfiniteScrollKey } from './';
import { Simulate } from 'react-dom/test-utils';
export var createDeprecatedInfiniteScrollDriver = function (wrapper) {
    var base = wrapper.$("." + deprecatedinfiniteScrollKey);
    return {
        itemsCount: function () { return base.$$('.item').count(); },
        scroll: function (scrollTop) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = (_a = Simulate).scroll;
                    return [4 /*yield*/, base.getNative()];
                case 1: return [2 /*return*/, _b.apply(_a, [_c.sent(), { target: { scrollTop: scrollTop } }])];
            }
        }); }); },
        wait: function (timeout) { return base.wait(timeout); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map